import { File } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import { FileItemView } from 'chat/messages/file/view'
import { useLayoutEffect, useRef } from 'react'
import { View } from 'react-native'
import Swiper from 'react-native-web-swiper'

interface Props {
  mediaFiles: File[] | undefined
  currentIndex: number | undefined
  setCurrentIndex: (index: number) => void
}

export function ChatDocumentViewerView({
  mediaFiles,
  currentIndex,
  setCurrentIndex,
}: Props) {
  const swiperRef = useRef<Swiper>(null)
  const styles = useStyles()
  useLayoutEffect(() => {
    if (currentIndex) {
      swiperRef.current?.goTo(currentIndex)
    }
  }, [currentIndex])

  if (!mediaFiles) {
    return null
  }
  const renderPages = () =>
    mediaFiles?.flatMap((item, index) => (
      <FileItemView
        item={{
          uri: item.currentVersion?.url!,
          mimeType: item.currentVersion?.fileMimeType!,
        }}
        index={index}
        currentIndex={currentIndex}
      />
    ))

  return (
    <View style={styles.container}>
      <Swiper onIndexChanged={setCurrentIndex} ref={swiperRef}>
        {renderPages()}
      </Swiper>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    backgroundColor: 'black',
  },
}))
